import { useEffect } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { CONTACT_EMAIL, PORTFOLIO_URL, LEGAL_UPDATED } from "../global";
import "./Legal.css";

function Legal() {
  useEffect(() => {
    document.title = "Mentions légales | Getout Paname";
    return () => {
      document.title = "Getout Paname";
    };
  }, []);

  return (
    <div className="container pa-legal">
      <PageHeader
        eyebrow="Informations légales"
        title="Mentions légales"
        intro="Qui édite Getout Paname, qui l'héberge, et d'où viennent les informations que vous y lisez."
      />

      <h2 className="pa-legal__h">Éditeur du site</h2>
      <dl className="pa-legal__dl">
        <dt>Éditeur</dt>
        <dd>
          Yanis ARENES, personne physique. Getout Paname est un projet
          indépendant et non commercial.
        </dd>

        <dt>Responsable de la publication</dt>
        <dd>Yanis ARENES</dd>

        <dt>Contact</dt>
        <dd>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </dd>

        <dt>Site de l'éditeur</dt>
        <dd>
          <a href={PORTFOLIO_URL} target="_blank" rel="noopener noreferrer">
            sinaysenera.dev
            <i className="ms-1 bi bi-box-arrow-up-right" aria-hidden="true"></i>
          </a>
        </dd>
      </dl>

      <div className="pa-prose">
        <h2>Hébergement</h2>
        <p>
          Le site est hébergé sur Firebase Hosting, service fourni pour l'Espace
          économique européen par&nbsp;:
        </p>
      </div>
      <dl className="pa-legal__dl">
        <dt>Hébergeur</dt>
        <dd>
          Google Ireland Limited
          <br />
          Gordon House, Barrow Street
          <br />
          Dublin 4, D04 E5W5, Irlande
          <br />
          Immatriculation irlandaise n°&nbsp;368047
        </dd>
      </dl>

      <div className="pa-prose">
        <h2>Source et licence des données</h2>
        <p>
          Les événements présentés proviennent intégralement du jeu de données
          ouvert «&nbsp;Que Faire à Paris&nbsp;? Évènements et activités
          &nbsp;», publié par la Direction de la Communication de la Ville de
          Paris sur{" "}
          <a
            href="https://opendata.paris.fr/explore/dataset/que-faire-a-paris-/information/"
            target="_blank"
            rel="noopener noreferrer"
          >
            opendata.paris.fr
          </a>
          .
        </p>
        <p>
          Ce jeu de données est diffusé sous licence{" "}
          <a
            href="http://opendatacommons.org/licenses/odbl/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Database License (ODbL)
          </a>
          . Conformément à cette licence, la paternité des données est attribuée
          à la Ville de Paris et le présent site n'en revendique aucune
          propriété.
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          Les contenus décrivant les événements (titres, textes, visuels et
          crédits photographiques) appartiennent à la Ville de Paris et aux
          organisateurs concernés. Ils sont affichés tels que publiés à la
          source.
        </p>
        <p>
          L'interface, le code et l'identité graphique de Getout Paname sont
          l'œuvre de l'éditeur.
        </p>

        <h2>Indépendance</h2>
        <p>
          Getout Paname n'est pas un service de la Ville de Paris. Le site n'est
          affilié ni à la Mairie de Paris, ni à aucun organisateur, salle ou
          lieu dont les événements sont référencés.
        </p>

        <h2>Limites de responsabilité</h2>
        <p>
          Les informations affichées sont reprises automatiquement de la source
          sans modification de leur contenu. Les dates, horaires, tarifs et
          conditions d'accès peuvent changer, et un événement peut être annulé
          ou complet sans que le site en soit informé. Avant de vous déplacer,
          vérifiez toujours l'information auprès de l'organisateur.
        </p>
        <p>
          Getout Paname ne vend aucun billet et n'effectue aucune réservation.
          Toute transaction se fait directement auprès de l'organisateur, sous
          sa seule responsabilité.
        </p>

        <h2>Liens sortants</h2>
        <p>
          Le site renvoie vers des sites tiers (organisateurs, billetteries,
          réseaux sociaux) sur lesquels l'éditeur n'exerce aucun contrôle et
          dont il ne saurait être tenu responsable du contenu.
        </p>

        <h2>Signaler une erreur</h2>
        <p>
          Une fiche inexacte, un événement qui n'existe plus&nbsp;? Écrivez à{" "}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Pour qu'une
          correction soit durable, elle doit aussi être signalée à la Ville de
          Paris, qui est à l'origine de la donnée.
        </p>
      </div>

      <p className="pa-legal__sibling">
        Voir aussi&nbsp;:{" "}
        <Link to="/confidentialite" className="pa-link">
          Politique de confidentialité
        </Link>
      </p>

      <p className="pa-legal__updated">
        Dernière mise à jour&nbsp;: {LEGAL_UPDATED}.
      </p>
    </div>
  );
}

export default Legal;
